<template>
  <div id="page-user-list" class="p-6">
    <div class="header-custome">
      <div>
        <h3>Dashboard</h3>
      </div>
    </div>
    <div class="dashboard-analytics-hld">
      <div class="dasboard-analytics-header">
        <h3>Check-in Analytics</h3>
        <div class="checkin-analytics-filter">
          <vs-button color="#5b058c" type="filled" class="text-white-today"
            >Today</vs-button
          >
          <!-- <div
            class="custom-search-hld checkin-analytics-date-filter pl-0 md:pl-4"
          >
            <vs-input
              class="inputx"
              placeholder="Select from date"
              v-model="value4"
            />
            <p>To</p>
            <vs-input
              class="inputx"
              placeholder="Select to date"
              v-model="value5"
            />
          </div> -->
        </div>
      </div>

      <div class="checkin-analytics-report-graph mt-12">
        <vs-tabs color="#5b058b">
          <vs-tab label="BY ROLE">
            <div class="tab-text">
              <!-- <span>Halvah ...</span> -->
              <div class="geo-checkin-graph">
                <apexchart
                  v-if="isDataLoadedForRoleGraph"
                  width="100%"
                  height="350"
                  type="bar"
                  :options="roleOptions"
                  :series="roleSeries"
                />
              </div>
            </div>
          </vs-tab>
          <vs-tab label="BY LOCATION">
            <div class="tab-text">
              <div class="geo-checkin-graph">
                <apexchart
                  v-if="isDataLoadedForLocationGraph"
                  width="100%"
                  height="350"
                  type="bar"
                  :options="locationOptions"
                  :series="locationSeries"
                />
              </div>
            </div>
          </vs-tab>


          <!-- <vs-tab label="BY DESIGNATION">
            <div class="tab-text">
              <span>Will be available in later updates</span>
            </div>
          </vs-tab>
          <vs-tab label="BY LOCATION">
            <div class="tab-text">
              <span>Will be available in later updates</span>
            </div>
          </vs-tab>
          <vs-tab label="BY DEVICE">
            <div class="tab-text">
              <span>Will be available in later updates</span>
            </div>
          </vs-tab>
          <vs-tab label="BY MONTH">
            <div class="tab-text">
              <span>Will be available in later updates</span>
            </div>
          </vs-tab> -->
        </vs-tabs>
      </div>
    </div>
  </div>
</template>
<script>
import VueApexCharts from "vue-apexcharts";
import moment from "moment-timezone";
import moduleCheckinReportManagement from "@/store/checkin-report-management/moduleCheckinReportManagement.js";
import moduleCheckinRoleManagement from "@/store/checkin-role-management/moduleCheckinRoleManagement.js";
export default {
  components: {},
  data() {
    return {
      tempCheckinLocations: [],
      checkinRoleList: [],
      primaryRoleCheckinList: [],
      isDataLoadedForRoleGraph: false,
      isDataLoadedForLocationGraph: false,
      value4: "",
      value5: "",
      roleOptions: {
        chart: {
          id: "slim-bar-chart",
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            columnWidth: "30%",
            dataLabels: {
              position: "top",
            },
          },
        },
        dataLabels: {
          enabled: true,
          style: {
            fontSize: "12px",
            colors: ["#304758"],
          },
        },
        xaxis: {
          categories: [],
          labels: {
            style: {
              fontSize: "12px",
            },
          },
        },
        yaxis: {
          title: {
            text: "Check-In",
            style: {
              fontSize: "12px",
            },
          },
          labels: {
            style: {
              fontSize: "12px",
            },
          },
        },
        colors: ["#008FFB"],
      },
      roleSeries: [
        {
          name: "Check-In",
          data: [],
        },
      ],
      locationOptions: {
        chart: {
          id: "slim-bar-chart",
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            columnWidth: "30%",
            dataLabels: {
              position: "top",
            },
          },
        },
        dataLabels: {
          enabled: true,
          style: {
            fontSize: "12px",
            colors: ["#304758"],
          },
        },
        xaxis: {
          categories: [],
          labels: {
            style: {
              fontSize: "12px",
            },
          },
        },
        yaxis: {
          title: {
            text: "Check-In",
            style: {
              fontSize: "12px",
            },
          },
          labels: {
            style: {
              fontSize: "12px",
            },
          },
        },
        colors: ["#008FFB"],
      },
      locationSeries: [
        {
          name: "Check-In",
          data: [],
        },
      ],
    };
  },

  components: {
    apexchart: VueApexCharts,
  },

  watch: {},

  methods: {
    fetchCheckinRoles() {
      var self = this;

      this.$store
        .dispatch("checkinRoleManagement/fetchGeoCheckinRoles")
        .then((res) => {
          self.checkinRoleList = [];
          if (res.data && res.data.length > 0) {
            res.data[0].map(function (item) {
              if (item.IsPublished) {
                self.checkinRoleList.push({
                  RoleId: item.RoleId,
                  Name: item.Name,
                  Color: item.Color,
                  ImageUrl: item.ImageUrl,
                  IsDefault: false,
                  Primary: "Make It Primary",
                });
              }
            });
            console.log("roles===", self.checkinRoleList);
          }
        });
    },
    fetchCheckinReports(
      customFromDate = null,
      customToDate = null,
      attendeeId = null
    ) {
      var self = this;
      const now = moment();
      const tomorrow = moment(now).add(1, "day");
      const datetime = now.format("YYYY-MM-DD 00:00:00");
      const tomorrowFormatted = tomorrow.format("YYYY-MM-DD 00:00:00");

      this.$vs.loading();
      this.reportsData = [];
      var data = {};
      if (customFromDate && customToDate) {
        data = {
          to: moment(customFromDate).format("YYYY-MM-DD 00:00:00"),
          from: moment(customToDate).format("YYYY-MM-DD 00:00:00"),
          users: attendeeId ? attendeeId : null,
        };
      } else {
        data = {
          from: datetime,
          to: tomorrowFormatted,
          users: attendeeId ? attendeeId : null,
        };
      }

      // this.filteredReportParameters = data;

      this.$store
        .dispatch("checkinreportManagement/fetchGeoCheckinReports", data)
        .then((res) => {
          //console.log("res====", res);

          if (res.data.data && res.data.data.length == 0) {
            this.$vs.loading.close();
            this.pageLoaded = true;
            this.reportsData = [];
          } else {
            var tempReport = {};
            this.primaryRoleCheckinList = [];
            res.data.data.map((reportData) => {
              console.log(
                "reportData===",
                reportData.attendee.CheckinPrimaryRole
              );
              if (reportData.attendee.CheckinPrimaryRole) {
                this.primaryRoleCheckinList.push(
                  reportData.attendee.CheckinPrimaryRole
                );
              }

              var duration = 0;
              var locations = [];
              reportData.data.map((reportCheckins) => {
                //console.log("reportCheckins===", reportCheckins);
                if (reportCheckins) {
                  duration += reportCheckins.duration
                    ? reportCheckins.duration
                    : 0;

                  locations.push(reportCheckins.location);

                  this.tempCheckinLocations.push(reportCheckins.location.Name);
                } else {
                  duration += 0;

                  locations.push([]);
                }
              });
              tempReport = {
                Name: reportData.attendee.Name,
                Email: reportData.attendee.Email,
                Designation: reportData.attendee.Designation,
                TotalDuration:
                  moment.utc(duration * 1000).format("HH:mm") + " hrs",
                ProfilePictureURL: reportData.attendee.ProfilePictureURL,
                CheckinRoles: reportData.attendee.CheckinRoles,
                Location: locations,
                AttendeeId: reportData.attendee.AttendeeId,
              };
              this.reportsData.push(tempReport);
            });
            console.log("arr 1=====", this.primaryRoleCheckinList);
            console.log("arr 2=====", this.checkinRoleList);
            console.log("arr 3======", this.tempCheckinLocations);

            const countMap = this.primaryRoleCheckinList.reduce((acc, id) => {
              acc[id] = (acc[id] || 0) + 1;
              return acc;
            }, {});

            const locationCountMap = {};
            this.tempCheckinLocations.forEach((item) => {
              if (locationCountMap[item]) {
                locationCountMap[item] += 1;
              } else {
                locationCountMap[item] = 1;
              }
            });

            Object.entries(locationCountMap).forEach(([item, count]) => {
              if (count > 1) {
                console.log(`Item: ${item}, Count: ${count}`);
                self.locationOptions.xaxis.categories.push(item);
                self.locationSeries[0].data.push(count);
              }
            });

            Object.entries(countMap).forEach(([id, count]) => {
              const object = this.checkinRoleList.find(
                (obj) => obj.RoleId === id
              );
              if (object) {
                self.roleOptions.xaxis.categories.push(object.Name);
                self.roleSeries[0].data.push(count);
              }
            });
            this.isDataLoadedForRoleGraph = true;
            this.isDataLoadedForLocationGraph = true;

            this.$vs.loading.close();
            this.pageLoaded = true;
            //}
          }
        });
    },
  },

  mounted() {},

  created() {
    if (!moduleCheckinRoleManagement.isRegistered) {
      this.$store.registerModule(
        "checkinRoleManagement",
        moduleCheckinRoleManagement
      );
      moduleCheckinRoleManagement.isRegistered = true;
    }
    this.fetchCheckinRoles();
    if (!moduleCheckinReportManagement.isRegistered) {
      this.$store.registerModule(
        "checkinreportManagement",
        moduleCheckinReportManagement
      );
      moduleCheckinReportManagement.isRegistered = true;
    }

    this.fetchCheckinReports();
  },
};
</script>